import type { TradeCancellationApi as IPostTradeOperationsApi } from 'epic/postTradeOperations/tradeCancellation/tradeCancellationEpics';
import { BlotterItemType } from 'models/blotters/BlotterType';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';

export function postTradeOperationsApiConnecter(http$: IHttpClient): IPostTradeOperationsApi {
  return {
    cancelTrade(tradeId: string, tradeType?: BlotterItemType, isin?: string): Observable<unknown> {
      return http$
        .post({
          url: `api/v1/trades/${tradeId}/do-cancel`,
          params: { tradeType, isin },
          parseErrorPayload: true,
        })
        .pipe(map(r => r.payload));
    },
  };
}
